// extracted by mini-css-extract-plugin
export var carrierTab = "_48-0";
export var carrierTabActive = "_48-1 _48-0";
export var carrierTabInactive = "_48-2 _48-0";
export var carrierTabLabel = "_48-3";
export var carrierTabLabelActive = "_48-4 _48-3";
export var carrierTabLabelInactive = "_48-5 _48-3";
export var carrierTabPercentage = "_48-6";
export var carrierTabPercentageActive = "_48-7 _48-6";
export var carrierTabPercentageInactive = "_48-8 _48-6";
export var carrierTabWinnable = "_48-9";
export var carrierTabWinnableActive = "_48-a _48-9";
export var carrierTabWinnableInactive = "_48-b _48-9";
export var comparisonContainer = "_48-d";
export var missingRateButton = "_48-n";
export var missingRateButtonActive = "_48-o _48-n";
export var missingRateButtonInactive = "_48-p _48-n";
export var missingRateButtonLabel = "_48-q";
export var missingRateButtonLabelActive = "_48-r _48-q";
export var missingRateButtonLabelInactive = "_48-s _48-q";
export var sidebar = "_48-c";
export var strategyButton = "_48-e";
export var strategyButtonActive = "_48-f _48-e";
export var strategyButtonDescription = "_48-k";
export var strategyButtonDescriptionActive = "_48-l _48-k";
export var strategyButtonDescriptionInactive = "_48-m _48-k";
export var strategyButtonInactive = "_48-g _48-e";
export var strategyButtonLabel = "_48-h";
export var strategyButtonLabelActive = "_48-i _48-h";
export var strategyButtonLabelInactive = "_48-j _48-h";
export var unitToggleButton = "_48-t";
export var unitToggleButtonActive = "_48-u _48-t";
export var unitToggleButtonInactive = "_48-v _48-t";
export var unitToggleButtonLabel = "_48-w";
export var unitToggleButtonLabelActive = "_48-x _48-w";
export var unitToggleButtonLabelInactive = "_48-y _48-w";